<template>
  <Slidebar @closeMe="closeSlidebar" :large="large" :extraLarge="extraLarge">
    <h4>Magnbreyta búnaði</h4>
    <ul>
      <li v-for="item in items" :key="item.bunadur_id">
        {{ item.heiti }}
      </li>
    </ul>
    <div>Veldu hverju þú vilt breyta</div>
    <v-select id="selectedType" name="selectedType" class="mb-3" v-model="selectedType" :options="types"> </v-select>
    <b-form @submit.prevent="validateBeforeSubmit" novalidate>
      <div v-if="selectedType && selectedType.id === 'description'">
        <b-form-group
          label-for="lysing"
          label="Lýsing"
          :state="submitted && errors.has('lysing') ? false : ''"
          :invalid-feedback="errors.first('lysing')"
        >
          <b-form-textarea
            id="lysing"
            name="lysing"
            type="text"
            v-model="description"
            :state="submitted && errors.has('lysing') ? false : ''"
            maxLength="1000"
            data-vv-as="lýsing"
          ></b-form-textarea>
        </b-form-group>
      </div>
      <div v-if="selectedType && selectedType.id === 'location'">
        <b-form-group
          label-for="stadsetning"
          label="Staðsetning"
          :state="submitted && errors.has('stadsetning') ? false : ''"
          :invalid-feedback="errors.first('stadsetning')"
        >
          <b-form-input
            id="stadsetning"
            name="stadsetning"
            type="text"
            v-model="location"
            :state="submitted && errors.has('stadsetning') ? false : ''"
            maxLength="1000"
            data-vv-as="staðsetning"
          ></b-form-input>
        </b-form-group>
      </div>
      <div v-if="selectedType && selectedType.id === 'active'">
        <b-form-group label-for="virkt" label="Virkt">
          <v-select id="virkt" name="virkt" v-model="active" :options="yesNo" :clearable="false"> </v-select>
        </b-form-group>
      </div>
      <div v-if="selectedType && selectedType.id === 'staffOrder'">
        <b-form-group label-for="starfsmPanta" label="Má starfsmaður panta">
          <v-select id="starfsmPanta" name="starfsmPanta" v-model="staffOrder" :options="yesNo" :clearable="false"> </v-select>
        </b-form-group>
      </div>
      <div v-if="selectedType && selectedType.id === 'studentOrder'">
        <b-form-group label-for="nemPanta" label="Má nemandi panta">
          <v-select id="nemPanta" name="nemPanta" v-model="studentOrder" :options="yesNo" :clearable="false"> </v-select>
        </b-form-group>
      </div>
      <br />
      <b-btn variant="primary" class="mr-2" v-if="selectedType" @click="validateBeforeSubmit" :disabled="saving"> Breyta </b-btn>
      <b-btn variant="dark" @click="closeSlidebar" :disabled="saving">Hætta við</b-btn>
    </b-form>
  </Slidebar>
</template>

<script>
import structure from '@/api/structure';
import { mapActions, mapGetters } from 'vuex';

import Slidebar from '@/components/common/Slidebar.vue';

export default {
  name: 'equipment-mass-editslidebar',
  props: ['items', 'large', 'extraLarge'],
  components: {
    Slidebar,
  },
  computed: {
    canEdit() {
      return this.loggedInUserHasWritePermission('skolahald_uppbygging');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      loading: false,
      types: [
        { id: 'description', label: 'Lýsing' },
        { id: 'location', label: 'Staðsetning' },
        { id: 'active', label: 'Virkt' },
        { id: 'staffOrder', label: 'Má starfsmaður panta' },
        { id: 'studentOrder', label: 'Má nemandi panta' },
      ],
      selectedType: '',
      description: '',
      loaction: '',
      active: { id: 0, label: 'Nei' },
      staffOrder: { id: 0, label: 'Nei' },
      studentOrder: { id: 0, label: 'Nei' },
      submitted: false,
      saving: false,
      yesNo: [
        { id: 1, label: 'Já' },
        { id: 0, label: 'Nei' },
      ],
    };
  },
  methods: {
    async validateBeforeSubmit() {
      try {
        this.submitted = true;
        this.errorList = [];
        await this.$validator.validateAll().then(response => {
          if (!response) throw 'FormValidationError'; // eslint-disable-line no-throw-literal
        });

        // Engar villur í formi.
        try {
          this.saving = true;
          const promises = [];
          this.items.forEach(i => {
            const data = {
              name: i.heiti,
              description: i.lysing,
              location: i.stadsetning,
              staffOrder: i.ma_starfsmadur_panta ? 1 : 0,
              studentOrder: i.ma_nemandi_panta ? 1 : 0,
              active: i.virkt ? 1 : 0,
            };
            const type = this.selectedType ? this.selectedType.id : '';
            switch (type) {
              case 'description':
                this.$set(data, 'description', this.description);
                break;
              case 'location':
                this.$set(data, 'location', this.location);
                break;
              case 'staffOrder':
                this.$set(data, 'staffOrder', this.staffOrder.id);
                break;
              case 'studentOrder':
                this.$set(data, 'studentOrder', this.studentOrder.id);
                break;
              case 'active':
                this.$set(data, 'active', this.active.id);
                break;
              default:
                break;
            }
            promises.push(structure.updateEquipment(i.bunadur_id, data));
          });
          Promise.all(promises).then(() => {
            this.displaySuccess('Búnaði breytt');
            this.closeSlidebar();
          });
        } catch (e) {
          // Aðgerð mistókst.
          this.failed = true;
          this.$log.debug(e);
          if (e.response && e.response.data && e.response.data.error) {
            this.displayError(e.response.data.error);
          } else {
            this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
          }
        }
      } catch (e) {
        // Villur í formi.
        this.$log.debug(e);
      } finally {
        this.saving = false;
      }
    },
    closeSlidebar() {
      this.$emit('closeSlidebar');
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  watch: {},
  created() {},
};
</script>

<style lang="scss"></style>
